import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import AdminSideMenu from '../components/AdminSideMenu';
import AdminAppNavbar from '../components/AdminAppNavbar';
import AdminSideMenuMobile from '../components/AdminSideMenuMobile';
import { useAdminAuthSlice } from '../../../store/slices/adminAuth';
import { useAdminNotificationsSlice } from '../../notifications/slice';

export default function AdminLayout() {
  useAdminAuthSlice();
  useAdminNotificationsSlice();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AdminSideMenu />
      <AdminAppNavbar onMenuOpen={() => setMobileOpen(true)} />
      <AdminSideMenuMobile open={mobileOpen} onClose={() => setMobileOpen(false)} />

      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          overflow: 'auto',
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
        })}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 1400,
            mx: 'auto',
            px: { xs: 2, sm: 3 },
            py: { xs: 10, md: 3 },
          }}
        >
          <Stack spacing={3}>
            <Outlet />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
